export const REFERENCE_REQUIRED = 'BROADCAST_REFERENCE_REQUIRED';
export const TOKEN_EXPIRED_MESSAGE = 'BROADCAST_TOKEN_EXPIRED_MESSAGE';
export const TOKEN_REMOVED = 'BROADCAST_TOKEN_REMOVED';
export const TOKEN_REPLACED = 'BROADCAST_TOKEN_REPLACED';
export const ENVIRONMENT_SET = 'BROADCAST_ENVIRONMENT_SET';
